import { cssUtil } from "../utils/cssUtil";
import { getBaseStyles } from "./commonStyles";

export function renderExternalFormWidget(context, widget, parent) {
    const breakpoint = context.currentBreakpoint;

    const device = widget?.properties?.[breakpoint];

    if (!device) return;

    const element = context.document.createElement("div");
    element.classList.add("widget", "external_form_widget");

    const styles = {
            ...getBaseStyles(widget, breakpoint),
            ...getStyles()
    };
    element.setAttribute("style", cssUtil.toStyleString(styles));
    element.setAttribute("data-widgetId", widget.uid);
    element.setAttribute("data-widgetType", widget.type);
    element.setAttribute("data-widgetParent", widget.parent);

    const textElement = context.document.createElement("p");
    textElement.innerHTML = "External Form";
    textElement.setAttribute("style", cssUtil.toStyleString({
        "color": "#FFFFFF",
        "font-size": "20px",
        "font-weight": "bold",
        "font-family": "Montserrat, sans-serif"
    }));
    element.appendChild(textElement);
    parent.appendChild(element);

    return element;
}

function getStyles() {
    const styles = {};
    styles['background-color'] = '#FF7A59';
    styles['display'] = 'flex';
    styles['align-items'] = 'center';
    styles['justify-content'] = 'center';
    return styles;
}       